import { render, staticRenderFns } from "./TradeEventNotification.vue?vue&type=template&id=0c508d74&scoped=true"
import script from "./TradeEventNotification.vue?vue&type=script&lang=js"
export * from "./TradeEventNotification.vue?vue&type=script&lang=js"
import style0 from "./TradeEventNotification.vue?vue&type=style&index=0&id=0c508d74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_cache-loader@4.1.0_webpack@4.47.0__css-load_b411938ae3dba6b80d9ee6ba07c3eefc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c508d74",
  null
  
)

export default component.exports